import clone from "lodash/clone";
import { CAMPAIGN_STATUS } from "../../helpers/constants";
import { getCampaignStatus } from "../.";

const getCampaignGroupByStatus = (campaigns, instanceTimezone) => {
  const campaignStatusValue = Object.values(CAMPAIGN_STATUS);
  return campaigns.reduce((prevValue, curValue) => {
    const status = getCampaignStatus(
      curValue.node.acfCampaignDate,
      instanceTimezone
    );
    const index = campaignStatusValue.indexOf(status);
    prevValue[index] = [...(prevValue[index] || []), curValue];
    return prevValue;
  }, {});
};

export const sortCampaigns = (campaigns = [], instanceTimezone) => {
  if (campaigns.length === 0) {
    return [];
  }
  const campaignsByGroup = getCampaignGroupByStatus(
    campaigns,
    instanceTimezone
  );
  const campaignSortedList = [];

  for (const status of Object.keys(campaignsByGroup).sort((a, b) => a - b)) {
    const sorted = campaignsByGroup[status].sort(
      (a, b) =>
        new Date(b.node.acfCampaignDate.campaignStartDate) -
        new Date(a.node.acfCampaignDate.campaignStartDate)
    );
    campaignSortedList.push(...sorted);
  }

  return campaignSortedList;
};
